import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './config';
import { initializeAnalytics } from './services/analyticsService';

// Analytics and masked session replay start with the application.
initializeAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

root.render(
  GOOGLE_CLIENT_ID ? (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID} locale="en">
      {app}
    </GoogleOAuthProvider>
  ) : app
);
